module.exports = __webpack_public_path__ + "static/img/pptImg.9367c4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/pptImg.png
// module id = XDos
// module chunks = 3